export const links=[
    {
        title:'LinkedIn',
        href:'https://www.linkedin.com/in/harshilgupta3',
        icon:''
    },
    {
        title:'Github',
        href:'https://github.com/Harshil0309',
        icon:''
    },
    {
        title:'Leetcode',
        href:'https://leetcode.com/harshil_gupta/',
        icon:''
    },

];